import {AssessmentGoal} from "./assessment-goal";
import {SourceOfEvidence} from "./source-of-evidence";
import {AppConstants} from "../../app-constants";
import {ProjectView} from "../classes/project-view.enum";
import {AssessmentObjective} from "./assessment-objective";
import {AssessmentMeasure} from "./assessment-measure";
import {PlanType} from "../classes/plan-type.enum";

export class AssessmentProject {
  id: number;
  requestKey: string;
  resourceURL: string;
  active: boolean;

  ILOCount: number;

  planType: PlanType;

  name: string;
  authors: any;
  projectStatus: {
    id: number,
    indicatorClassName:string,
    indicatorClassName2:string,
    class: string,
    name:string, //important
    requestKey:string, //important
    editable:boolean,
    active: boolean,
    caption: string,
    className: string
  };

  //reporting period
  reportingPeriod: {
    deletable: boolean,
    editable: boolean,
    description: string,
    type: any,
    requestKey: string,
    id: number,
    name: string,
    active: boolean
  };

  currentView: ProjectView;

  projectData: {
    mission: string,
    missionExpanded: boolean,
    vision: string,
    visionExpanded: boolean,
    expandedAll: boolean,
    mappingExpandAll: boolean,
    attachmentsExpanded: boolean,
    projectGoalList: any[] //important
  };
  goalList: AssessmentGoal[]; //also important?

  outcomesList: AssessmentObjective[];
  measuresList: AssessmentMeasure[];

  sourcesOfEvidence: SourceOfEvidence[];

  goalCount: number;
  objectiveCount: number;
  measureCount: number;
  targetCount: number;
  qualitativeCount: number;
  quantitativeCount: number;
  findingCount: number;
  sourceID: number;

  //ownership
  owner: {
    name: string,
    requestKey: string
  };

  //users
  authorList: any[];
  canRemoveTeamMember: boolean;

  //lock
  editLockMember: any; //must have a name
  editLocked: boolean;

  //users and locking
  hasAccess: boolean;
  isOwner: boolean;
  isReviewer: boolean;
  isAuthor: boolean;
  organization: {
    id: number,
    requestKey: string,
    name: string
  };

  //template related
  projectTemplateID: number;
  projectTemplate: any;

  //attachments
  projectAttachmentList: any[];

  relatedProjectList: any[];

  siStandardsList: any[];
  siGeneralEducationElementsList: any[];
  siInstitutionalPrioritiesList: any[];
  siStrategicInitiativesList: any[];

  projectHtml: string;
  calculatedResourceURL: string;

  sortOrder: number;

  nameDisabled: boolean = false;

  constructor(
    id: number = 0,
    requestKey: string = "",
    resourceUrl: string = "",
    active: boolean = true,
    ILOCount: number = 0,
    planType: PlanType = PlanType.Assessment,
    name: string = "",
    authors: any[] = [],
    projectStatusId: number = 0,
    projectStatusIndicatorClassName: string = "",
    projectStatusIndicatorClassName2: string = "",
    projectStatusClass: string = "",
    projectStatusClassName: string = "",
    projectStatusName: string = "",
    projectStatusRequestKey: string = "",
    projectStatusCaption: string = "",
    projectStatusEditable: boolean = true,
    projectStatusActive: boolean = true,
    reportingPeriodDeletable: boolean = true,
    reportingPeriodEditable: boolean = true,
    reportingPeriodDescription: string = "",
    reportingPeriodType: any = null, //todo what type is this?
    reportingPeriodRequestKey: string = "",
    reportingPeriodId: number = 0,
    reportingPeriodName: string = "",
    reportingPeriodActive: boolean = true,
    mission: string = "",
    vision: string = "",
    projectGoalList: AssessmentGoal[] = [],
    outcomesList: AssessmentObjective[] = [],
    measuresList: AssessmentMeasure[] = [],
    sourcesOfEvidence: SourceOfEvidence[] = [],
    sourceID: number = 0,
    ownerName: string = "",
    ownerRequestKey: string = "",
    authorList: any[] = [],
    canRemoveTeamMember: boolean = true, //todo what type is this?
    editLockMember:any  = null, //todo what type is this?
    editLocked:boolean  = false,
    hasAccess:boolean  = true,
    isOwner:boolean  = true,
    isReviewer:boolean  = true,
    isAuthor:boolean  = true,
    organizationId: number = 0,
    organizationRequestKey: string = "",
    organizationName: string = "",
    projectTemplateID: number = 0,
    projectTemplate: any = null, //todo what type is this?
    projectAttachmentList: any[] = [], //todo what type is this?
    relatedProjectList: any[] = [], //todo what type is this?
    siStandardsList: any[] = [], //todo what type is this?
    siGeneralEducationElementsList: any[] = [], //todo what type is this?
    siInstitutionalPrioritiesList: any[] = [], //todo what type is this?
    siStrategicInitiativesList: any[] = [], //todo what type is this?
    projectHtml: string = "",
    calculatedResourceURL: string = "",
    sortOrder: number = 0,
    nameDisabled: boolean = false,
    goalCount: number = 0,
    objectiveCount: number = 0,
    measureCount: number = 0,
    targetCount: number = 0,
    qualitativeCount: number = 0,
    quantitativeCount: number = 0,
    findingCount: number = 0,
    currentView: ProjectView = ProjectView.Assess
  ) {
    this.id = id;
    this.requestKey= requestKey;
    this.resourceURL = resourceUrl;
    this.active = active;

    this.ILOCount = ILOCount;

    this.name = name;
    this.authors = authors;
    this.planType = planType;

    this.projectStatus = {
      id : projectStatusId,
      indicatorClassName : projectStatusIndicatorClassName,
      indicatorClassName2 : projectStatusIndicatorClassName2,
      class : projectStatusClass,
      name : projectStatusName,
      requestKey : projectStatusRequestKey,
      editable : projectStatusEditable,
      active : projectStatusActive,
      caption : projectStatusCaption,
      className : projectStatusClassName
    };

    //reporting period
    this.reportingPeriod = {
      deletable : reportingPeriodDeletable,
      editable : reportingPeriodEditable,
      description : reportingPeriodDescription,
      type : reportingPeriodType,
      requestKey : reportingPeriodRequestKey,
      id : reportingPeriodId,
      name : reportingPeriodName,
      active : reportingPeriodActive
    };

    this.projectData = {
      mission : mission,
      vision: vision,
      missionExpanded: true,
      visionExpanded: true,
      expandedAll: true,
      mappingExpandAll: true,
      attachmentsExpanded: true,
      projectGoalList: [] //todo not used?
    };

    this.goalList = projectGoalList; //also important?
    this.outcomesList = outcomesList; //non assisgned outcomes
    this.measuresList = measuresList; //non assisgned outcomes

    this.sourcesOfEvidence = sourcesOfEvidence;

    this.goalCount = goalCount;
    this.objectiveCount = objectiveCount;
    this.measureCount = measureCount;
    this.targetCount = targetCount;
    this.qualitativeCount = qualitativeCount
    this.quantitativeCount = quantitativeCount;
    this.findingCount = findingCount;
    this.sourceID = sourceID;

    //ownership
    this.owner = {
      name: ownerName,
      requestKey: ownerRequestKey
    };

    //users
    this.authorList = authorList;
    this.canRemoveTeamMember = canRemoveTeamMember;

    //lock
    this.editLockMember = editLockMember;
    this.editLocked = editLocked;

    //users and locking
    this.hasAccess = hasAccess;
    this.isOwner = isOwner;
    this.isReviewer = isReviewer;
    this.isAuthor = isAuthor;
    this.organization = {
      id: organizationId,
      requestKey: organizationRequestKey,
      name: organizationName
    };

    //template related
    this.projectTemplateID = projectTemplateID;
    this.projectTemplate = projectTemplate;

    //attachments
    this.projectAttachmentList = projectAttachmentList;

    this.relatedProjectList = relatedProjectList;

    this.siStandardsList = siStandardsList;
    this.siGeneralEducationElementsList = siGeneralEducationElementsList;
    this.siInstitutionalPrioritiesList = siInstitutionalPrioritiesList;
    this.siStrategicInitiativesList = siStrategicInitiativesList;

    this.projectHtml = projectHtml;
    this.calculatedResourceURL = calculatedResourceURL;

    this.sortOrder = sortOrder;

    this.nameDisabled = nameDisabled;

    if(this.projectStatus.requestKey !== "") {
      this.projectStatus.class = AppConstants.assessmentProjectStatusesByGuid[ this.projectStatus.requestKey ].class;
      this.projectStatus.name = AppConstants.assessmentProjectStatusesByGuid[ this.projectStatus.requestKey ].name;
    } else {
      this.projectStatus.class = AppConstants.assessmentProjectStatuses.notStarted.class;
      this.projectStatus.name = AppConstants.assessmentProjectStatuses.notStarted.name;
    }

    this.currentView = currentView;
  }
};

export interface projectStatus {
  id: number,
  indicatorClassName:string,
  indicatorClassName2:string,
  class: string,
  name:string, //important
  requestKey:string, //important
  editable:boolean,
  active: boolean,
  caption: string,
  className: string
};

export interface OutlineView {
  showGoals: boolean,
  showOutcomes: boolean,
  showMeasures: boolean
}

export class projectExpandStates {
  projectRequestKey: string;
  missionExpanded: boolean;
  visionExpanded: boolean;
  expandedAll: boolean;
  mappingExpandAll:boolean;
  attachmentsExpanded: boolean;
  goals: Record<
    string, {
    expanded: boolean, outcomes: Record<
      string, {
      expanded: boolean,
      supportedInitiativeExpanded: boolean,
      actionPlanExpanded: boolean,
      measures: Record<
        string, {
        expanded :boolean,
        targets: Record<
          string, {
          expanded: boolean
        }>
      }>
    }>
  }>

  constructor() {
    this.projectRequestKey =  String();
    this.missionExpanded = true;
    this.visionExpanded = true;
    this.expandedAll = true;
    this.mappingExpandAll = true;
    this.attachmentsExpanded = true;
    this.goals = {};
  }
}

export class ProjectViewStates {
  leftClosed: boolean;
  rightClosed: boolean;
  rightMax: boolean;

  constructor() {
    this.leftClosed = false;
    this.rightClosed = false;
    this.rightMax = false;
  }
}
